import React from 'react';

export const COMING_SOON = 'COMING SOON';

const ComingSoonTag = () => {
  return (
    <span
      className={`bg-[rgba(67,126,247,0.2)] border border-[#437EF7] rounded-md text-[#437EF7] font-bold tracking-wider outline-none px-[8px] py-[4px]`}
    >
      {COMING_SOON}
    </span>
  );
};

export default ComingSoonTag;
